<template>
  <div>
    <canvas :id="idcanvas"></canvas>
  </div>
</template>
<script>
import Chart from "chart.js";
import graph from "@/helpers/graph";
// import graph from "@/helpers/graph";

export default {
  props: {
    datagraph: {
      type: Object
    },
    height: Number,
    cambio: Number
  },
  data() {
    return {
      idcanvas: "",
      chart: null,
      config: null,
      colorbase: [
        "#293462",
        "#f76262",
        "#216583",
        "#aee7e8",
        "#28c3d4",
        "#fbc99d",
        "#ed1250",
        "#10ddc2",
        "#042f4b",
        "#15b7b9",
        "#f57170",
        "#248ea9"
      ]
    };
  },
  created() {
    this.idcanvas = Math.random()
      .toString(36)
      .substr(2, 9);
  },
  mounted() {
    if (this.datagraph.data) {
      this.render(this);
    }
  },
  methods: {
    render(_this) {
      // const _this = this;
      Chart.defaults.global.defaultFontFamily = "'Nunito', sans-serif"; // con esto configuramos el tipo de letra
      Chart.defaults.global.tooltips.backgroundColor =
        "rgba(50, 115, 220, 0.9)"; // con esto se configura el fondo del tooltip
      let datasets = _this.sortData(_this.datagraph);
      const ctx = document.getElementById(_this.idcanvas);
      if (_this.height) {
        ctx.height = _this.height;
      } else {
        ctx.height = 320;
      }
      ctx.getContext("2d");
      _this.config = {
        // The type of chart we want to create
        type: _this.datagraph.typeGraphic,

        // The data for our dataset
        data: {
          labels: _this.datagraph.labels,
          datasets: datasets
        },
        // Configuration options go here
        options: _this.datagraph.options
      };
      if (_this.chart) {
        // si la grafica ya existia la destruimos
        _this.chart.destroy();
      }
      _this.chart = new Chart(ctx, this.config);
    },
    sortData(datagraph) {
      const datasets = [];
      const _this = this;
      let control = 0;
      if (datagraph.typeGraphic === "pie") {
        datagraph.data.forEach(function(k, v) {
          const d = {};
          d.label = datagraph.series[v];
          d.borderColor = [];
          d.backgroundColor = [];
          control = 0;
          k.forEach(function(k1, v1) {
            if (control === _this.colorbase.length) {
              // esto es para que repita los colores
              control = 0;
            }
            d.borderColor.push(_this.colorbase[control]);
            d.backgroundColor.push(graph.hexToRgbA(_this.colorbase[control]));
            control++;
          });
          d.borderWidth = 3;
          d.data = k;
          datasets.push(d);
        });
      } else {
        datagraph.data.forEach(function(k, v) {
          const d = {};
          d.label = datagraph.series[v];
          d.borderColor = datagraph.colors[v];
          d.backgroundColor = graph.hexToRgbA(datagraph.colors[v]);
          d.borderWidth = 3;
          d.data = k;
          if (datagraph.datasetOverride[v]) {
            d.type = datagraph.datasetOverride[v].type;
          }
          datasets.push(d);
        });
      }
      return datasets;
    }
  },
  watch: {
    cambio(newv, oldv) {
      if (this.datagraph.data) {
        this.render(this);
      }
    }
  }
};
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/dashboard/Graph.vue